const Navbar = () => {
  return ( 
    <nav className="navbar">
      <h1>Charles Website</h1>
      <div className="links">
        <a href="/">Home</a>
        <a href="/experience">Experiences</a>
      </div>
    </nav>
   );
}
 
export default Navbar;